import { render } from "./CustomerGroupPricingForZone.html?vue&type=template&id=61f6617c&scoped=true"
import script from "./CustomerGroupPricingForZone.js?vue&type=script&lang=js"
export * from "./CustomerGroupPricingForZone.js?vue&type=script&lang=js"

import "./CustomerGroupPricingForZone.css?vue&type=style&index=0&id=61f6617c&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f6617c"]])

export default __exports__